/**
 * Collection facets behaviors (progressive enhancement only).
 *
 * - Filters, sorting and pagination are plain GET forms/links and work
 *   fully without this script (a <noscript> fallback replaces the dialog).
 * - This script only opens/closes the mobile facets <dialog> (native
 *   focus trap, Escape and focus restore come from the platform) and
 *   auto-submits the toolbar sort select, hiding its fallback button.
 * - Event delegation on document: theme editor section re-renders need
 *   no re-initialization. No per-filter listeners, no fetch, no deps.
 */
(function () {
  'use strict';

  if (window.SuplementariaCollectionFacetsInitialized) return;
  window.SuplementariaCollectionFacetsInitialized = true;

  function hideSortFallbacks(root) {
    (root || document).querySelectorAll('[data-sort-apply]').forEach(function (button) {
      button.hidden = true; // com JS, o select auto-submete
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var opener = target.closest('[data-facets-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    var closer = target.closest('[data-facets-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }

    // Clique no backdrop (o próprio dialog, fora do container interno)
    if (target.matches && target.matches('dialog.facets-dialog')) {
      target.close();
    }
  });

  // URLs limpas com JS: campos vazios não entram na query (sem JS o GET
  // puro envia vazios e a Shopify os ignora — funcionalidade intacta).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.facets, .collection__sort')) return;
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (input.value === '') input.disabled = true;
    });
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-sort-auto]')) return;
    var form = select.form;
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  document.addEventListener('shopify:section:load', function (event) {
    hideSortFallbacks(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hideSortFallbacks(document);
    });
  } else {
    hideSortFallbacks(document);
  }
})();
